import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';

function List() {

    const pathFrontEnd = '/gci/maiscontrole-pagamentos/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/maiscontrole-pagamentos/delete`,
        endpoint: `${endpointBackend}gci/maiscontrole-pagamentos/getall`
    }

    let list = {
        labelTitle: 'Mais Controle - Pagamentos',
        fieldsShowOnDelete: ['descricao'],
        canAdd: false,
        viewActionColumn: false,
        columns: [
            {
                name: 'id_lancamento',
                label: 'ID Lançamento'
            },
            {
                name: 'nome_obra',
                label: 'Obra'
            },
            {
                name: 'data_competencia',
                label: 'Data Competência'
            },
            {
                name: 'data_vencimento',
                label: 'Data Vencimento'
            },
            {
                name: 'data_pagamento',
                label: 'Data Pagamento'
            },
            {
                name: 'numero_parcela',
                label: 'Nº Parcela'
            },
            {
                name: 'valor_parcela',
                label: 'Valor Parcela'
            },
            {
                name: 'valor_pago',
                label: 'Valor Pago'
            },
            {
                name: 'valor_desconto',
                label: 'Valor Desconto'
            },
            {
                name: 'valor_juros_e_multa',
                label: 'Valor Juros/Multa'
            },
            {
                name: 'fornecedor',
                label: 'Fornecedor',
                width: '25%'
            },
            {
                name: 'descricao',
                label: 'Descrição',
                width: '25%'
            },
            {
                name: 'numero_documento',
                label: 'Número Documento',
                width: '15%'
            },
            {
                name: 'categoria',
                label: 'Categoria',
                width: '20%'
            },
            {
                name: 'grupo',
                label: 'Grupo',
                width: '20%'
            },
            {
                name: 'plano_de_conta',
                label: 'Plano de Conta',
                width: '20%'
            },
            {
                name: 'condicao_pagamento',
                label: 'Condição Pagamento',
                width: '20%'
            },
            {
                name: 'forma_pagamento',
                label: 'Forma Pagamento',
                width: '20%'
            },
            {
                name: 'quem_paga',
                label: 'Quem Paga',
                width: '20%'
            },
            {
                name: 'conta_bancaria',
                label: 'Conta Bancária',
                width: '20%'
            },
            {
                name: 'id_obra',
                label: 'ID Obra'
            },
            {
                name: 'centro_de_custo',
                label: 'Centro de Custo',
                width: '20%'
            },
            {
                name: 'indice_item_orcamento',
                label: 'Índice Item Orçamento',
                width: '15%'
            },
            {
                name: 'ordem_de_compra',
                label: 'Ordem de Compra',
                width: '15%'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                canAdd={list.canAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}

export default List;
